





































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapState, mapGetters, mapActions } from 'vuex';

import AppHeader from 'frontend/components/AppHeader.vue';
import LandingHeaderV2 from 'frontend/views/landing/LandingHeaderV2.vue';
import LandingFooter from 'frontend/views/landing/LandingFooter.vue';
import JoinCTA from 'frontend/views/landing/JoinCTA.vue';
import { User, Testimonial } from 'frontend/types';

@Component({
  metaInfo() {
    return {
      title: 'Testimonials',
    };
  },
  components: {
    AppHeader,
    LandingHeaderV2,
    LandingFooter,
    JoinCTA,
  },
  computed: {
    ...mapGetters('globals', ['isAuthenticated']),
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapState('testimonials', ['items', 'page', 'totalPages', 'isBusy']),
    ...mapGetters('testimonials', ['sourceLabel', 'userCategoryLabel']),
    ...mapActions('testimonials', ['changeCurrentPage']),
  },
})
export default class Testimonials extends Vue {
  private activeType: 'Featured' | 'All' = 'Featured';
  private activeCategory: number | null = null;
  private isTypeDropdownActive: boolean = false;
  private page!: number;
  private totalPages!: number;
  private isBusy!: boolean;

  private changeCategory(categoryId: number): void {
    this.activeCategory = categoryId;

    this.$store.dispatch('testimonials/changeFilters', {
      type: this.activeType,
      userCategory: this.activeCategory,
    });
  }

  private changeType(type: 'Featured' | 'All'): void {
    this.activeType = type;
    this.isTypeDropdownActive = false;

    this.$store.dispatch('testimonials/changeFilters', {
      type: this.activeType,
      userCategory: this.activeCategory,
    });
  }

  private previousPage(): void {
    const page = this.page - 1;

    if (page < 1 || this.isBusy) {
      return;
    }

    (this.$refs.userReviews as Element).scrollIntoView({ behavior: 'smooth' });
    this.$store.dispatch('testimonials/changeCurrentPage', {
      page,
      type: this.activeType,
      userCategory: this.activeCategory,
    });
  }

  private nextPage(): void {
    const page = this.page + 1;

    if (page > this.totalPages || this.isBusy) {
      return;
    }

    (this.$refs.userReviews as Element).scrollIntoView({ behavior: 'smooth' });
    this.$store.dispatch('testimonials/changeCurrentPage', {
      page,
      type: this.activeType,
      userCategory: this.activeCategory,
    });
  }
}
